import Enum from "./Enum";

export default Enum.create( {
	WELCOME: "WELCOME",
	PERSONAL_GROWTH: "PERSONAL_GROWTH",
} );
